<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Donation Preferences">
                    <FormRow inline>
                        <LazyCurrencySelector :currencies="['USD', 'ILS', 'CAD']"/>
                    </FormRow>
                    <AmountSelector/>
                    <ErrorLabel field="amount" />
                    <div class="donation-frequency">
                        <DonationFrequency />
                      </div>
                    <TransactionFee />
                  <br/>
                  <label class="control-label">
                    I want to earmark my donation for
                  </label>
                  <OuisraelDesignation />
                  <InHonorOf :initialOpen="params.inHonorOf === 'true'" />
                </FormSection>


                <FormSection title="">
                    <FormRow inline>
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/"/>
                  </FormRow>
                </FormSection>
                <FormSection title="">
                    <DonorAddress />
                </FormSection>

                <FormSection title="Payment Information" last>
                  <FormRow>
                    <Receipt />
                  </FormRow>
                    <FormRow inline>
                        <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton showAmount btnText="Donate"/>
                <br/>
                <p class="other-means">
                  For other means of donating - please contact us by:<br/>
                  <strong>TEL:</strong> (02) 560-9100<br/>
                  <strong>FAX:</strong> (02) 566-0156<br/>
                  <strong>EMAIL:</strong> <a href="mailto:ABerman@ouisrael.org">ABerman@ouisrael.org</a>
                </p>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { usePaymentForm } from '@/shared/use-payment-form';
import { defineComponent, watch, nextTick } from "vue";
import { queryParams } from "~/shared/query-params";


export default defineComponent({
  setup() {
    const { getValue, settings, setValue, form } = usePaymentForm();


    const params = queryParams();

    if (params.amount) {
      nextTick(() => setValue('amount', params.amount));
    }

    if (params.currency) {
      nextTick(() => setValue('currency', params.currency.toUpperCase()));
    }

    if (params.dayOfMonth) {
      nextTick(() => setValue('dayOfMonth', params.dayOfMonth));
    }

    if (params.donationtype === 'monthly' || params.donationType === 'monthly') {
      nextTick(() => setValue('dayOfMonth', '' + new Date().getDate()));
    }



    watch(
      () => getValue("custom.designation"),
      (val) => {
        if (val == "Zula" || !val) {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "Zula");
          setValue("applications.0.subCampaign", "");
        }
        else if(val == "Womens Division" || !val) {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "OU Israel Women's Division (Layla)");
          setValue("applications.0.subCampaign", "");
        }
         else if(val == "Torah Initiatives" || !val) {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "Torah Initiatives");
          setValue("applications.0.subCampaign", "");
        }
         else if(val == "NCSY Israel" || !val) {
          setValue("applications.0.department", "NCSY_Israel");
          setValue("applications.0.campaign", "General Donation");
          setValue("applications.0.subCampaign", "");
        }
        else if(val == "Camp Dror" || !val) {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "Camp Dror");
          setValue("applications.0.subCampaign", "");
        }
        else if(val == "Torah Tidbits" || !val) {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "Torah Tidbits");
          setValue("applications.0.subCampaign", "");
        }
        else if(val == "OU Kashrut" || !val) {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "Kashrut Education");
          setValue("applications.0.subCampaign", "");
        }
        else if(val == "Yachad Israel" || !val) {
          setValue("applications.0.department", "Yachad_Israel");
          setValue("applications.0.campaign", "	General Donation");
          setValue("applications.0.subCampaign", "");
        }
        else {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "General Donation");
          setValue("applications.0.subCampaign", "");
        }
      }
    );



    watch(
      () => getValue("custom.subDesignation"),
      (val) => {
        if(val == "Liba Banim" || !val) {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "Zula");
          setValue("applications.0.subCampaign", "Liba Banim");
         }
        else if(val == "Liba Banot" || !val) {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "Zula");
          setValue("applications.0.subCampaign", "Liba Banot");
        }
        else if(val == "Zusha" || !val) {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "Zula");
          setValue("applications.0.subCampaign", "Zusha");
        }
        else {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "Zula");
          setValue("applications.0.subCampaign", "");
        }
      }
    );


    return {
       form,
      getValue,
      params,
      settings,
      setValue,
    }
  },
})
</script>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
  min-width: 12%;
  max-width: 12%;
  &:nth-child(6n) {
    padding-right: 10px;
  }
  @media (max-width: 768px) {
    min-width: 30%;
    max-width: 30%;
    &:nth-child(6n) {
      padding-right: 0;
    }
    &:nth-child(3n) {
      padding-right: 10px;
    }
  }
  @media (max-width: 480px) {
    min-width: 48%;
    max-width: 48%;
    &:nth-child(3n) {
      padding-right: 0;
    }
    &:nth-child(2n) {
      padding-right: 10px;
    }
  }
}
::v-deep label.label__consent {
    font-size: 13px;
    line-height: 1.4;
}
.control-label {
  font-size: 14px;
  color: #222;
  display: block;
  margin-bottom: 5px;
}
.donation-frequency {
  padding-right: 0 !important;
  ::v-deep .radio-part {
    min-width: 50% !important;
    max-width: 50% !important;
    margin-bottom: 0 !important;
    &:nth-child(2n) {
      padding-right: 0 !important;
    }
    label {
      padding: 10px !important;
    }
  }
}

</style>
